import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { MonthResponseSchema } from "../response/MonthResponse";

const API_VERSION = 'v3';

interface FilterProps {
    property_id: string;
    base_on: string;
    start_date: string;
    end_date: string;
    room_type_id?: string;
}

interface MonthProps {
    filter?: FilterProps;
    type: string | null;
}

const useMonth = (params: MonthProps) => {
    return useQuery({
        queryKey: [
            'report',
            'month',
            'agent',
            params.type, // Tambahkan type ke dalam queryKey
            JSON.stringify(params.filter) // Pastikan filter bisa digunakan sebagai key
        ],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/${API_VERSION}/agent-report-monthly`, {
                    params: {
                        filter: params.filter
                    }
                });

                // Validasi response
                const validationResult = MonthResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Agent report month data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Agent report month`, error);
                throw error;
            }
        },
        enabled: !!params.filter && !!params.filter.property_id && !!params.filter.start_date && !!params.filter.end_date && params.type === "monthly",
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false
    });
};

export default useMonth;